/* __next_internal_client_entry_do_not_use__ useServerRenderedCarouselTiles,ServerRenderedCarouselTilesContextProvider auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
var ServerRenderedCarouselTilesContext = /*#__PURE__*/ createContext(undefined);
export var useServerRenderedCarouselTiles = function() {
    return useContext(ServerRenderedCarouselTilesContext);
};
export var ServerRenderedCarouselTilesContextProvider = function(param) {
    var productTiles = param.productTiles, children = param.children;
    return /*#__PURE__*/ _jsx(ServerRenderedCarouselTilesContext.Provider, {
        value: {
            productTiles: productTiles
        },
        children: children
    });
};
